import {useQuery} from '@tanstack/react-query';

import {User} from '@entities/user';
import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getReferrals, GetReferralsParams} from '../api';
import {QUERY__REFERRALS} from '../queryKeys';

export const useGetReferrals = <SelectedData = GetListOutput<User>>(
  params?: GetReferralsParams,
  options?: QueryOptionsForList<User, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__REFERRALS, params],
    queryFn: () => getReferrals(params),
    ...options,
  });
